import { getPlantystAuthToken, getUser } from "./api";

export interface MeasurementsResponse {
    _embedded: {
        measurement?: {
            measurementId: number;
            title: string;
        }[];
    };
};

export interface ServiceProvidersResponse {
    _embedded: {
        serviceProvider: ServiceProvider[];
    }
}
export interface ServiceProvider {
    id: string;
    title: string;
    services: Service [];
}
export interface Service {
    id: string;
    title: string;
    type: string;
    configuration: {
        clientGuid: string;
    }
}

const portalApiRequests: { [key: string]: Promise<any> | undefined; } = {};
export async function portalApiFetch<T>(
    relativeUrl: string,
    requestInit?: Partial<RequestInit>,
    cacheDurationSeconds: number = 5 * 60,
    requestKey?: string): Promise<T> {
    const existingRequest = portalApiRequests[requestKey || relativeUrl];
    if (!existingRequest) {
        const newRequest = (async () => {
            const user = await getUser();
            const plantystAuthToken = await getPlantystAuthToken();
            const response = await fetch(user.plantystApiUrl + relativeUrl, {
                ...(requestInit || {}),
                headers: {
                    "Authorization": "Bearer " + plantystAuthToken,
                    "Accept": "application/hal+json",
                    ...(requestInit?.headers || {}),
                },
            });
            window.setTimeout(() => {
                delete portalApiRequests[requestKey || relativeUrl];
            }, (cacheDurationSeconds || 0) * 1000);
            return await response.json();
        })();
        portalApiRequests[requestKey || relativeUrl] = newRequest;
        return await newRequest;
    } else {
        return await existingRequest;
    }
}

export async function fetchMeasurements() {
    return await portalApiFetch<MeasurementsResponse>("measurements");
}
